/* eslint-disable no-nested-ternary */
export default {
  convertListToJson(string) {
    return string.split('\n')
      .map((line) => {
        const [id, ...names] = line.split(' ');

        return {
          id,
          name: names.join(' '),
        };
      });
  },
  parseISOString(s) {
    const d = s.split(/\D+/);
    const date = new Date(Date.UTC(d[0], --d[1], d[2]));
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    return date;
  },
  formatDate(date) {
    if (!date) {
      return null;
    }
    const newDate = date.split(/\D+/);
    return `${newDate[2]}/${newDate[1]}/${newDate[0]}`;
  },
  debounce(fn, delay) {
    let timeoutID = null;
    function delayed(...args) {
      clearTimeout(timeoutID);
      const self = this;
      timeoutID = setTimeout(() => {
        fn.apply(self, args);
      }, delay);
    }

    return delayed;
  },
  convertDateFormat(timestamp) {
    if (!timestamp) {
      return null;
    }
    const currentDate = new Date(timestamp * 1000);
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    return [date, month, year];
  },
  validURL(str) {
    if (str === '') return null;
    const pattern = new RegExp('^(?:(?:https?|ftp):\\/\\/)?'
      + '(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169.254|192.168)'
      + '(?:\\.\\d{1,3}){2})(?!172.(?:1[6-9]|2\\d|3[0-1])'
      + '(?:.d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])'
      + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}'
      + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|'
      + '(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)'
      + '(?:\\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*'
      + '(?:\\.(?:[a-z\u00a1-\uffff]{2,})))'
      + '(?::\\d{2,5})?(?:\\/\\S*)?$', 'i');
    return !!pattern.test(str);
  },
  orderBy(list, prop) {
    return list.sort((a, b) => ((a[prop].toLowerCase() > b[prop].toLowerCase())
      ? 1 : (a[prop].toLowerCase() === b[prop].toLowerCase())
        ? ((a.size > b.size) ? 1 : -1) : -1));
  },

  getLocalStorageItem(itemKey) {
    return localStorage.getItem(itemKey);
  },
  setLocalStorageItem(itemKey, itemValue) {
    localStorage.setItem(itemKey, JSON.stringify(itemValue));
  },
  objLength(object) {
    let length = 0;
    for (const key in object) {
      if (object.hasOwnProperty(key)) length++;
    }
    return length;
  },
  convertDateToString(date) {
    if (!date) return '';
    const adjustedDate = date;
    return `${adjustedDate.getFullYear()}-${this.convertNumberToString(adjustedDate.getMonth() + 1)}-${this.convertNumberToString(adjustedDate.getDate())}`;
  },
  convertNumberToString(number) {
    return number && number < 10 ? `0${number}` : number;
  },
};
